import React from 'react'
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined'
import DeleteIcon from '@mui/icons-material/Delete'
import Popup from '../../../../components/Common/Popup'
import { HelpItem } from '../../services/types/APIResponseType'

interface HelpAccordionProps {
  item: { question: string; answer: string; _id: string }
  onEdit: (item: HelpItem) => void
  onDelete: (id: string) => void
  isDeleteModal: boolean
  setIsDeleteModal: (isOpen: boolean) => void
  handleClose: () => void
}

const HelpAccordion: React.FC<HelpAccordionProps> = ({
  item,
  onEdit,
  onDelete,
  isDeleteModal,
  setIsDeleteModal,
  handleClose,
}) => {
  return (
    <>
      <Accordion className="relative !bg-transparent !text-white">
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{ color: 'white' }} />}
          aria-controls="panel1-content"
          id="panel1-header"
          className="text-[18px] h-16"
        >
          {item.question}
        </AccordionSummary>
        <AccordionDetails className="text-start text-[16px] text-[#7D7D7D] flex items-center justify-between">
          <div>{item.answer}</div>
          <div className="flex space-x-2 mx-4">
            <Button onClick={() => onEdit(item)}>
              <ModeEditOutlineOutlinedIcon className="cursor-pointer text-white" />
            </Button>
            <Button onClick={() => setIsDeleteModal(true)}>
              <DeleteIcon className="cursor-pointer text-white" />
            </Button>
            {isDeleteModal && (
              <Popup
                title="Delete Help Confirmation"
                message="Are you sure you want to delete this help?"
                buttonText="Continue"
                showYesNoButtons={true}
                onYesClick={() => onDelete(item._id)}
                onNoClick={() => {
                  handleClose()
                  setIsDeleteModal(false)
                }}
              />
            )}
          </div>
        </AccordionDetails>
      </Accordion>
      <div className="w-full h-[2px] bottom-0 bg-border-gradient"></div>
    </>
  )
}

export default HelpAccordion
